import * as Yup from 'yup';

interface ForgotPasswordForm {
  username: string;
}

const validarErroForm = async (data: ForgotPasswordForm) => {
  const schema = Yup.object().shape({
    username: Yup
      .string()
      .required('Usuário é obrigatório'),
  });

  await schema.validate(data, {
    abortEarly: false,
  });
};

export default validarErroForm;
